import { getEmailErrorMessage, getPasswordErrorMessage } from 'utils/validators';
import { PasswordRequirements } from './PasswordRquirements';
import {
  PASSWORD_CONFIRMATION_ERROR_NOTIFICATION,
  RESET_PASSWORD_DESCRIPTION,
  RESET_PASSWORD_HEADER,
  RESET_PASSWORD_SENT_DESCRIPTION,
  RESET_PASSWORD_SENT_HEADER,
  SET_NEW_PASSWORD_DESCRIPTION,
  TO_EASY_PASSWORD_NOTIFICATION,
  WRONG_EMAIL_NOTIFICATION,
} from 'consts';

export const resetSentFormFields = [
  {
    type: 'title',
    fieldName: 'title',
    value: RESET_PASSWORD_SENT_HEADER,
  },
  {
    type: 'description',
    fieldName: 'value',
    value: RESET_PASSWORD_SENT_DESCRIPTION,
  },
];

export const resetFormFields = [
  {
    type: 'title',
    fieldName: 'title',
    value: RESET_PASSWORD_HEADER,
  },
  {
    type: 'notification',
    fieldName: 'resetPasswordMessage',
  },
  {
    type: 'description',
    fieldName: 'value',
    value: RESET_PASSWORD_DESCRIPTION,
  },
  {
    type: 'email',
    fieldName: 'email',
    placeholder: 'Email',
    required: true,
    errorMessage: WRONG_EMAIL_NOTIFICATION,
    validator: getEmailErrorMessage,
  },
];

export const setPassFormFields = [
  {
    type: 'title',
    fieldName: 'title',
    value: RESET_PASSWORD_HEADER,
  },
  {
    type: 'notification',
    fieldName: 'setPasswordMessage',
  },
  {
    type: 'description',
    fieldName: 'value',
    value: SET_NEW_PASSWORD_DESCRIPTION,
  },
  {
    type: 'component',
    fieldName: 'agree',
    child: <PasswordRequirements />,
  },
  {
    type: 'password',
    fieldName: 'password',
    placeholder: 'Password',
    required: true,
    errorMessage: TO_EASY_PASSWORD_NOTIFICATION,
    validator: getPasswordErrorMessage,
  },
  {
    type: 'password',
    fieldName: 'password_confirmation',
    placeholder: 'Confirm Password',
    required: true,
    errorMessage: PASSWORD_CONFIRMATION_ERROR_NOTIFICATION,
    validator: (value: string | number | boolean) => !!value,
  },
];
